<template>
  <div class="">
    <el-card class="box-card">
      <div class="search-form" style="text-align: left" v-if="!isType">
        <el-form ref="searchForm" :inline="true" :model="searchForm" label-width="80px" label-position="left"
          class="demo-form-inline" size="small">         
          <el-form-item :label="$t('product.list.projectName')">
            <el-input clearable size="small" v-model="searchForm.name" :placeholder="$t('product.list.pleaseEnterProjectName')"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button icon="el-icon-search" type="primary" size="small" @click="handleSearch">{{ $t('product.list.search') }}</el-button>
            <el-button icon="el-icon-refresh-right" type="primary" size="small" @click="resetSearch">{{ $t('product.list.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="" style="margin-bottom: 15px;text-align:left" v-if="!isType">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">{{ $t('product.list.addProduct') }}</el-button>
      </div>
      <el-table :data="dataList" border size="small" height="600">
        <el-table-column type="index" :index="indexMethod" :label="$t('product.list.serialNo')" width="60"></el-table-column>
        <el-table-column prop="name" :label="$t('product.list.projectName')" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('product.list.lengthWidthHeight')" show-overflow-tooltip width='150'>
          <template slot-scope="scope">
            {{scope.row.length}}*{{scope.row.width}}*{{scope.row.height}}
          </template>
        </el-table-column>
        <el-table-column prop="weight" :label="$t('product.list.weight')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="freight_class" :label="$t('product.list.freightClass')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="battering_type" :label="$t('product.list.palletType')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ bat(scope.row.battering_type) }}
          </template>
        </el-table-column>
        <el-table-column prop="product_unit" :label="$t('product.list.productUnit')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ unit(scope.row.product_unit) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('product.list.cargoCategoryCode')" width="150" show-overflow-tooltip>-</el-table-column>
        <el-table-column :label="$t('product.list.subcategoryCode')" width="130" show-overflow-tooltip>-</el-table-column>
        <!-- <el-table-column prop="isDefault" label="是否默认" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.isDefault == 1 ? $t('product.list.yes') : $t('product.list.no')}}
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('product.list.operation')" :width="isType ? 60 : 140">
          <template slot-scope="scope">
            <div>
              <span style="color: #409eff; cursor: pointer" v-if="!isType" @click="handleEdit(scope.row)">{{ $t('product.list.edit') }}</span>
              <el-divider direction="vertical" v-if="!isType"></el-divider>
              <span style="color: #f40000; cursor: pointer" @click="handleDel(scope.row)" v-if="!isType">{{ $t('product.list.delete') }}</span>
              <span style="color: #409EFF; cursor: pointer" @click="handleSelect(scope.row)" v-if="isType">{{ $t('product.list.select') }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagization-box">
        <CustomPagization
          :background="true"
          :currentPage="current"
          :total="total"
          :pageSize="size"
          @current-change="currentChange"
        />
      </div>
    </el-card>

    <!-- 表单弹窗 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="title"
      append-to-body
      :visible.sync="formVisible"
      width="900px"
      :before-close="closeDialog"
    >
      <Form
        ref="formModal"
        :record="record"
        v-if="formVisible"
        @ok="editSuccess"
        append-to-body
      />
    </el-dialog>
  </div>
</template>

<script>
import Form from "./form";
import { list, productDel } from '@/api/ltl/product'
import { JudgePalletTypeArrFind, productUnitFind } from "@/common/common.js";
export default {
  props: {
    isType: {
      type: [Boolean],
      default: () => {
        return false
      }
    }
  },
  components: {
    Form,
  },
  data() {
    return {
      formVisible: false,
      record: {},
      title: this.$t('product.list.addProductDialog'),
      searchForm: {},
      current: 1,
      size: 20,
      total: 1,
      dataList: [],
    };
  },
    computed: {
    bat() {
      return (val) => {
        let name = JudgePalletTypeArrFind(val)
        return name
      };
    },
    unit() {
      return (val) => {
        let name = productUnitFind(val)
        return name
      };
    },
  },
  mounted(){
    if(this.isType){
      this.searchForm.address_type = this.isType
    }
    this.init()
  },
  methods: {
    // 获取列表
    init(){
      list({
        u_id: JSON.parse(window.localStorage.getItem("userInfo1")).user_id,
        page: this.current,
        limit: this.size,
        ...this.searchForm
      }).then(res => {
        if(res.code == 1){
          this.dataList = []
          this.dataList = res.data.data
          this.total = res.data.total
        }
      })
    },
    // 关闭弹框
    closeDialog() {
      this.record = {};
      this.formVisible = false;
    },
    //新增、修改成功的回调
    editSuccess() {
      this.formVisible = false;
      this.init();  //刷新列表
    },
    //视频监控站点新增
    handleAdd() {
      this.title = this.$t('product.list.addProductDialog')
      this.record = {}
      this.formVisible = true
    },
    //视频监控站点修改
    handleEdit(record) {
      this.title = this.$t('product.list.editProductDialog')
      this.record = {
        ...record
      }
      this.formVisible = true
    },
    //视频监控站点删除
    handleDel(record) {
      const _that = this;
      this.$confirm(this.$t('product.list.confirmDelete'), this.$t('product.list.warmTip'), {
        type: "warning",
      })
        .then(() => {
          productDel({ 
            u_id: JSON.parse(window.localStorage.getItem("userInfo1")).user_id,
            id: record.id 
          }).then(res => {
            if(res.code == 1){
              this.current = 1
              this.$message.success(res.msg);
              this.init();
            }else{
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 选择地址
    handleSelect(scope){
      this.$emit('ok',scope)
    },
    // table首列序号
    indexMethod(index) {
      return (this.current - 1) * this.size + index + 1;
    },
    // 页数变化
    currentChange(current) {
      this.current = current;
      this.init();
    },
    // 重置筛选
    resetSearch() {
      this.$refs["searchForm"].resetFields();
      this.searchForm = {}
      this.value1 = []
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.handleSearch();
    },
    // 去筛选
    handleSearch() {
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.pagization-box {
  overflow: hidden;
  margin-top: 10px;

  .el-pagination {
    float: right;
  }
}
/deep/ {
  .el-table {
    thead {
      color: #fff;
      font-weight: 500;
      background: #F5F7FA;
      color: #606266;
      & th {
        background-color: transparent;
      }
      & tr {
        background-color: transparent;
      }
    }
  }
}
</style>